import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
import {
  downloadEntityTemplate,
  massUploadEntities,
  validateMassUpload,
} from "../../../actions/Utilities/Entity";
import Modal from "../../../components/Modal";
import ConfirmBoxDelete from "../../../components/ConfirmBoxDelete";
import EditButton from "../../../components/EditButton";
import HideButton from "../../../components/HideButton";
import { MassUploadTable } from "./MassUploadTable";
import { MassUploadExpandedRowShow } from "./MassUploadExpandedRowShow";
import SaveDataButton from "../../../components/SaveDataButton";
import { toast } from "../../../components/toastNotification";
import UploadFileButton from "../../../components/UploadFileButton";
import TemplateButton from "../../../components/TemplateButton";
import { getLicenseType, getStates } from "../../../actions/Utilities/Common";
import * as XLSXFiles from "xlsx";

const MassUpload = ({ isOpen, setMassUploadModal, loboptions }) => {
  localStorage.setItem("ModalSelected", "");
  const [xlsx, setXlsx] = useState(null);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState();
  const [allData, setAllData] = useState([]);
  const [validData, setValidData] = useState([]);
  const [invalidData, setInvalidData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("All");
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();
  const [showEdit, setShowEdit] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleClear, setToggleCleared] = useState(false);
  const [, setIsBulkSelected] = useState(false);
  // const [show, setShow] = useState(false);
  const [origData, setOrigData] = useState([]);
  const [buttonSaveText, setButtonSaveText] = useState("Save Data");
  const [show, setShow] = useState(false);
  const [DisplayNote, setDisplayNote] = useState(false);
  const [licenseTypeOptions, setlicenseTypeOptions] = useState([]);
  const [states, setStates] = useState([]);

  // const [state, dispatch] = useReducer(reducer, initialState);

  useQuery("LicenseTypes", getLicenseType, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setlicenseTypeOptions(
        res.map((license) => {
          return {
            label: license.licenseTypeName,
            value: license.licenseTypeId,
          };
        })
      );
    },
  });

  useQuery("States", getStates, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setStates(
        res.map((data) => {
          return { label: data.state, value: data.stateId };
        })
      );
    },
  });

  useEffect(() => {
    const scriptShim = document.createElement("script");
    scriptShim.async = true;
    scriptShim.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/shim.min.js";
    scriptShim.integrity =
      "824a6ade25af712b2dabb1dc9d30f3441b5b1652fd7fa43a9f6ba99607849a6334c1baf0085047e4d2692a06e4ed299af067d71ffdf7986225cc041c6d8d71b8"; //C0nF!esH1m //sha512
    scriptShim.crossOrigin = "anonymous";

    const scriptXLS = document.createElement("script");
    scriptXLS.async = true;
    scriptXLS.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/xlsx.full.min.js";
    scriptXLS.integrity =
      "ce7e2434109f7c48061d1a110f5d2082e827dd41a0d9bb3950be8e3adea03f7508aa287b5c177754cf32dab771212d7de2f03d8a19d685b0dfc8a8452fd8172f"; //C0nF!eXLs //sha512
    scriptXLS.crossOrigin = "anonymous";

    scriptXLS.onload = () => setXlsx(XLSXFiles);

    document.body.appendChild(scriptShim);
    document.body.appendChild(scriptXLS);

    let timer = setTimeout(() => setLoading(false), 2000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const UploadFile = (e) => {
    if (e.target.files.length > 0) {
      const reader = new FileReader();
      const excelFile = e.target.files[0];
      reader.onload = (e) => {
        const result = e?.target?.result;
        try {
          const readedData = xlsx.read(result, {
            type: "binary",
          });
          const wsname = readedData.SheetNames[0];
          const ws = readedData.Sheets[wsname];
          const dataParse = xlsx.utils.sheet_to_json(ws, { header: 1 });
          const wb = xlsx.read(result, {
            type: "binary",
            cellDates: true,
            dateNF: "YYYY-MM-DD",
          });
          const xData = xlsx.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          if (
            dataParse[0].includes("Entity Name required") &&
            dataParse[0].includes("State required")
          ) {
            toast.fire(
              "Uploading Entity Failed",
              "Invalid file, please check file and re-upload again",
              "error"
            );
            setData([]);
            setDisplayNote(false);
          } else if (xData.length > 0) {
            setData(xData);
            setDisplayNote(true);
          }
        } catch (err) {
          toast.fire(
            "Uploading Entity Failed",
            "Invalid file, please check file and re-upload again",
            "error"
          );
          setData([]);
          setDisplayNote(false);
        }
      };
      reader.readAsBinaryString(excelFile);
      e.target.value = null;
    }
  };

  const updateRow = (formData) => {
    try {
      let updatedData = [];
      let newValidData = [];
      let newInvalidData = [];

      for (const x of origData) {
        updatedData.push(x === selectedData ? formData : x);
      }

      setAllData(updatedData);
      setOrigData(updatedData);

      for (const x of updatedData) {
        if (x.isValid) {
          newValidData.push(x === selectedData ? formData : x);
        } else if (!x.isValid) {
          newInvalidData.push(x === selectedData ? formData : x);
        }
      }
      setValidData(newValidData);
      setInvalidData(newInvalidData);

      return true;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (data.length > 0) {
      setLoading(true);

      var xData = data.map((entity) => {
        return {
          entityName:
            String(entity["Entity Name \r\nrequired"]) === undefined ||
            String(entity["Entity Name \r\nrequired"]) === null ||
            String(entity["Entity Name \r\nrequired"]) === "undefined"
              ? ""
              : String(entity["Entity Name \r\nrequired"]),
          state:
            String(entity["State\r\nrequired "]) === undefined ||
            String(entity["State\r\nrequired "]) === null ||
            String(entity["State\r\nrequired "]) === "undefined"
              ? ""
              : String(entity["State\r\nrequired "]),
          entityEin:
            String(entity["Entity EIN"]) === undefined ||
            String(entity["Entity EIN"]) === null ||
            String(entity["Entity EIN"]) === "undefined"
              ? ""
              : String(entity["Entity EIN"]),
          licenseNumber:
            String(entity["License Number"]) === undefined ||
            String(entity["License Number"]) === null ||
            String(entity["License Number"]) === "undefined"
              ? ""
              : String(entity["License Number"]),
          licenseTypeName:
            String(entity["License Type"]) === undefined ||
            String(entity["License Type"]) === null ||
            String(entity["License Type"]) === "undefined"
              ? ""
              : String(entity["License Type"]),
          expirationDate:
            entity["Expiration Date"] === undefined ||
            entity["Expiration Date"] === null ||
            entity["Expiration Date"] === "undefined"
              ? ""
              : entity["Expiration Date"],
          drlp1:
            String(entity["DRPL1"]) === undefined ||
            String(entity["DRPL1"]) === null ||
            String(entity["DRPL1"]) === "undefined"
              ? ""
              : String(entity["DRPL1"]),
          drlp1licenseType:
            String(entity["DRPL1 License Type"]) === undefined ||
            String(entity["DRPL1 License Type"]) === null ||
            String(entity["DRPL1 License Type"]) === "undefined"
              ? ""
              : String(entity["DRPL1 License Type"]),
          drlp1expDate:
            new Date(entity["DRPL1 Expiration Date"]) === "Invalid Date"
              ? ""
              : new Date(entity["DRPL1 Expiration Date"])
                  .toISOString()
                  .split("T")[0],
          drlp1licenseNumber:
            String(entity["DRPL1 License Number"]) === undefined ||
            String(entity["DRPL1 License Number"]) === null ||
            String(entity["DRPL1 License Number"]) === "undefined"
              ? ""
              : String(entity["DRPL1 License Number"]),
          comments:
            String(entity["Comments"]) === undefined ||
            String(entity["Comments"]) === null ||
            String(entity["Comments"]) === "undefined"
              ? ""
              : String(entity["Comments"]),
          disregardedForTax:
            String(entity["Disregarded For Tax"]) === undefined ||
            String(entity["Disregarded For Tax"]) === null ||
            String(entity["Disregarded For Tax"]) === "undefined"
              ? ""
              : String(entity["Disregarded For Tax"]),
          notes:
            String(entity["Notes"]) === undefined ||
            String(entity["Notes"]) === null ||
            String(entity["Notes"]) === "undefined"
              ? ""
              : String(entity["Notes"]),
        };
      });

      validateMassUpload(xData).then((res) => {
        if (res?.status === 400 || res?.status === 500) {
          setLoading(false);
          toast.fire("Failed", "Invalid File", "error");
        } else if (res) {
          setAllData(res);
          setOrigData(res);
          var tempValidData = [];
          var tempInvalidData = [];
          res?.map((prodCode) => {
            if (prodCode.isValid) tempValidData.push(prodCode);
            else tempInvalidData.push(prodCode);
          });
          setValidData(tempValidData);
          setInvalidData(tempInvalidData);
          setLoading(false);
          setSelectedTab("All");
        }
      });
    } else {
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (!isOpen) {
      setAllData([]);
      setOrigData([]);
      setInvalidData([]);
      setValidData([]);
    }
  }, [isOpen]);
  const SaveMassUploadData = () => {
    const typeName = validData.flatMap((data) =>
      licenseTypeOptions.filter(
        (option) => option.label === data.licenseTypeName
      )
    );
    const stateName = validData.flatMap((data) =>
      states.filter((option) => option.label === data.state)
    );

    setButtonSaveText("Saving...");
    const user = localStorage.getItem("userName");
    const entities = validData.map((x, index) => {
      return {
        ...x,
        stateId: stateName[index]?.value,
        licenseTypeId: typeName[index]?.value,
        createdBy: user,
        modifiedBy: user,
        createdOn: new Date().toISOString(),
        updatedOn: new Date().toISOString(),
        updatedBy: user,
      };
    });
    massUploadEntities(entities)
      .then((res) => {
        if (res.data === "duplicate") {
          toast.fire(
            "Adding new Entity failed",
            "Entity already exist",
            "error"
          );
        } else {
          queryClient.invalidateQueries("Entity");
          setAllData([]);
          setInvalidData([]);
          setValidData([]);
          DownloadInvalidData();
          setMassUploadModal(false);
          toast.fire("Success", "Your data has been saved", "success");
        }
      })
      .catch((e) => {
        toast.fire(
          "Save Failed",
          "We encountered an error when saving your data!",
          "error"
        );
      });
  };

  const DownloadTemplate = () => {
    downloadEntityTemplate().then((content) => {
      var url = window.URL.createObjectURL(content.data);

      let tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", "Entity Mass Upload - Template.xlsx");
      tempLink.click();
    });
  };

  const DownloadInvalidData = () => {
    if (invalidData.length > 0) {
      var xData = invalidData.map((entity) => {
        return {
          "Entity Name": entity.entityName,
          State: entity.state,
          "Entity EIN": entity.entityEin,
          "License Number": entity.licenseNumber,
          "License Type": entity.licenseTypeName,
          "Expiration Date": entity.expirationDate,
          DRPL1: entity.drlp1,
          "DRPL1 License Type": entity.drlp1licenseType,
          "DRPL1 Expiration Date": entity.drlp1expDate,
          "DRPL1 License Number": entity.drlp1licenseNumber,
          Comments: entity.comments,
          "Disregarded For Tax": entity.disregardedForTax,
          Notes: entity.notes,
        };
      });
      var wb = xlsx.utils.book_new();
      wb.Props = {
        Title: "Invalid Entities for Mass Upload",
        CreatedDate: new Date(),
      };
      wb.SheetNames.push("Sheet1");
      var ws = xlsx.utils.json_to_sheet(xData);
      wb.Sheets["Sheet1"] = ws;
      xlsx.writeFile(wb, `Entity Mass Upload - Invalid Data.xlsx`);
    }
  };

  const handleActions = (row, isEdit = false) => {
    const updatedData = origData.map((d) => {
      if (d === row) {
        d.expandRow = !d.expandRow;
        setSelectedData(row);
      }
      return d;
    });
    if (isEdit === true) {
      setShow(updatedData);
      setShowEdit(true);
      setDisplayNote(false);
    } else {
      setShow(false);
      setShowEdit(false);
      setDisplayNote(true);
    }
  };
  const handleDelete = () => {
    const newData = origData.filter((x) => !selectedRows.includes(x));
    setAllData(newData);
    setValidData(validData.filter((x) => !selectedRows.includes(x)));
    setInvalidData(invalidData.filter((x) => !selectedRows.includes(x)));
    setOrigData(newData);
    setOpenModal(false);
    setSelectedRows([]);
    setToggleCleared(!toggleClear);
    if (selectedTab === "Invalid" || selectedTab === "Valid") {
      handleSelectedTab(selectedTab, newData);
    }
  };
  const handleSelectedRowsChange = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const columns = [
    {
      name: "Findings",
      cell: (row) => {
        // return <div>{row.isValid ? "Valid" : "Invalid"}</div>;
        return <div>{row.isValid ? "Valid" : row.findings}</div>;
      },
    },
    {
      name: "Entity Name",
      cell: (row) => {
        return <div>{row.entityName}</div>;
      },
    },
    {
      name: "State",
      cell: (row) => {
        return <div>{row.state}</div>;
      },
    },
    {
      name: "Entity EIN",
      cell: (row) => {
        return <div>{row.entityEin}</div>;
      },
    },
    {
      name: "License Number",
      cell: (row) => {
        return <div>{row.licenseNumber}</div>;
      },
    },
    {
      name: "License Type",
      cell: (row) => {
        return <div>{row.licenseTypeName}</div>;
      },
    },
    {
      name: "Expiration Date",
      cell: (row) => {
        const formattedDate =
          new Date(row.expirationDate) === "Invalid Date"
            ? ""
            : new Date(row.expirationDate).toLocaleDateString("en-US", {
                timeZone: "UTC",
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              });

        return <div>{formattedDate}</div>;
      },
    },
    {
      name: "DRPL1",
      cell: (row) => {
        return <div>{row.drlp1 || ""}</div>;
      },
    },
    {
      name: "DRPL1 License Type",
      cell: (row) => {
        return <div>{row.drlp1licenseType || ""}</div>;
      },
    },
    {
      name: "DRPL1 License Number",
      cell: (row) => {
        return <div>{row.drlp1licenseNumber || ""}</div>;
      },
    },
    {
      name: "DRPL1 Expiration Date",
      cell: (row) => {
        const formattedDate =
          new Date(row.drlp1expDate) === "Invalid Date"
            ? ""
            : new Date(row.drlp1expDate).toLocaleDateString("en-US", {
                timeZone: "UTC",
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              });
        return <div>{formattedDate}</div>;
      },
    },
    {
      name: "Comments",
      cell: (row) => {
        return <div>{row.comments || ""}</div>;
      },
    },
    {
      name: "Disregarded For Tax",
      cell: (row) => {
        return <div>{row.disregardedForTax || ""}</div>;
      },
    },
    {
      name: "Notes",
      cell: (row) => {
        return <div>{row.notes || ""}</div>;
      },
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => {
        return (
          <div className="flex 2xl:flex-row flex-col justify-center items-center ">
            <div className="flex flex-row">
              {row.expandRow ? (
                <HideButton
                  buttonText="Hide"
                  onClick={() => {
                    handleActions(row);
                  }}
                />
              ) : (
                ""
              )}
              {row.expandRow ? (
                ""
              ) : (
                <EditButton
                  className={
                    (show || selectedRows.length > 0
                      ? "opacity-50"
                      : "opacity-100") + ""
                  }
                  disabled={showEdit || selectedRows.length > 0 ? true : false}
                  buttonText="Edit"
                  onClick={() => {
                    handleActions(row, true);
                  }}
                />
              )}
            </div>
          </div>
        );
      },
    },
  ];

  const tabs = ["All", "Valid", "Invalid"];
  const handleSelectedTab = (tab, data) => {
    setSelectedTab(tab);
    // eslint-disable-next-line default-case
    switch (tab) {
      case "All":
        return setAllData(origData);
      case "Valid":
        if (data !== null) {
          const valids = data.filter((data) => data.isValid);
          return setAllData(valids);
        } else {
          const valids = origData.filter((data) => data.isValid);
          return setAllData(valids);
        }

      case "Invalid":
        if (data !== null) {
          const invalids = data.filter((data) => !data.isValid);
          return setAllData(invalids);
        } else {
          const invalids = origData.filter((data) => !data.isValid);
          return setAllData(invalids);
        }
    }
  };

  const closeModal = () => {
    setMassUploadModal(false);
    setShow(false);
    setShowEdit(false);
    setDisplayNote(true);
    setData([]);
    setSelectedRows([]);
    setOrigData([]);
    setSelectedTab("All");
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        closeModal();
      }}
      closeOutside={false}
      className="entity-modal"
    >
      <ConfirmBoxDelete
        ModalTitle="Delete Entity Record"
        qConfirmation={"Are you sure you want to delete entity record(s)?"}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onClickFunction={handleDelete}
      />
      <div className="font-bold text-xl flex items-center my-2">
        <div className="text-base text-primary font-bold">
          Entity Mass Upload
        </div>
        <div className="ml-auto flex items-center">
          <TemplateButton
            onClick={DownloadTemplate}
            disabled={showEdit || selectedRows.length > 0}
          />
          <UploadFileButton onChange={UploadFile} disabled={false} />
        </div>
      </div>
      <div className="mt-2 h-1 w-full border-b-2 border-secondary" />

      <div>
        <div className="flex items-center">
          {tabs.map((tab) => {
            return (
              <button
                key={tab}
                onClick={() => handleSelectedTab(tab, null)}
                className={`border-b-4 font-medium text-sm text-tertiary cursor-pointer transition py-3 px-5  
                     ${
                       selectedTab === tab
                         ? "border-primary font-bold bg-gray-50"
                         : "border-transparent  hover:bg-gray-50"
                     }`}
              >
                {tab}
              </button>
            );
          })}
          {(selectedTab === "Valid" || selectedTab === "All") && !showEdit
            ? validData.length > 0 && (
                <div className="ml-auto">
                  <SaveDataButton
                    className={
                      selectedRows.length === 0 &&
                      buttonSaveText === "Save Data"
                        ? "opacity-100"
                        : "opacity-50 cursor-not-allowed border"
                    }
                    disabled={
                      selectedRows.length === 0 &&
                      buttonSaveText === "Save Data"
                        ? false
                        : true
                    }
                    onClick={SaveMassUploadData}
                    buttonValue={buttonSaveText}
                  ></SaveDataButton>
                </div>
              )
            : invalidData.length > 0 && (
                <div className="ml-auto flex items-center gap-x-2 py-2 text-red-500">
                  <p className="font-bold italic inline-block mr-1 ">Note:</p>
                  Your file has/have invalid data. Invalid entries will be
                  returned after upload.
                </div>
              )}
        </div>
        <div className="">
          {DisplayNote && data.length >= 1 ? (
            <div className="text-secondary italic text-xs3 mt-5 mx-6">
              <p className="font-bold italic inline-block mr-1">Note: </p>
              Tick the box to delete some data.
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className="mt-4 border rounded shadow-md overflow-y-auto"
          id="entity_massupload_table_container"
          style={{
            height: data.length > 3 ? "400px" : "auto",
          }}
        >
          <div className="overflow-x-auto">
            <MassUploadTable
              data={
                selectedTab === "Valid"
                  ? validData
                  : selectedTab === "Invalid"
                  ? invalidData
                  : allData
              }
              selectableRows={DisplayNote && selectedRows}
              columns={columns}
              loading={loading}
              isNote={DisplayNote}
              expandableRowsComponent={(row) => {
                setSelectedData(row.data);
                return (
                  <MassUploadExpandedRowShow
                    data={row.data}
                    isEdit={showEdit}
                    updateRow={(updatedRow) => updateRow(updatedRow)}
                    setShowEdit={setShowEdit}
                    setOrigData={setOrigData}
                    setAllData={setAllData}
                    origData={origData}
                    setValidData={setValidData}
                    setInvalidData={setInvalidData}
                    setShow={setShow}
                    setDisplayNote={setDisplayNote}
                    selectedTab={selectedTab}
                    handleSelectedTab={handleSelectedTab}
                  />
                );
              }}
              expandableRowsComponentProps={selectedData}
              expandableRowExpanded={(row) => row.expandRow}
              onSelectedRowsChange={handleSelectedRowsChange}
              selectedRows={selectedRows}
              setOpenModal={setOpenModal}
              setIsBulkSelected={setIsBulkSelected}
              clearSelectedRows={toggleClear}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MassUpload;
